import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';
import Styles from './styles.module.scss';
import { GOLD } from '../../../../data/permissions';
import NonPremiumNewsContent from './NonPremiumNewsContent';
import PremiumNewsContent from './PremiumNewsContent';

const cx = classNames.bind(Styles);

const PremiumPublicationNews = () => {
  const isGold = useSelector((state) => (
    state.subscriptions.permissions.access_levels.includes(GOLD)
  ));
  return (
    <div className={cx('premiumPublicationNews')}>
      <div className={cx('premiumPublicationNews__title')}>
        News
      </div>
      {isGold && <PremiumNewsContent />}
      {!isGold && <NonPremiumNewsContent />}
    </div>
  );
};

export default PremiumPublicationNews;
